import { Observable } from 'rxjs';
import { CallStatusType } from '../enum/call-status-type.enum';
import { CallData, DeviceInfo } from '../interface';
export abstract class MediaAdapterBase {
    abstract setGuid(): void;

    abstract initLocalMedia(): Observable<void>;
    abstract destroyLocalMedia(): void;

    abstract getMicDevices(): Observable<DeviceInfo[]>;
    abstract getCameraDevices(): Observable<DeviceInfo[]>;
    abstract getAudioDevices(): Observable<DeviceInfo[]>;

    abstract setMic(enabled: boolean): Observable<void>;
    abstract setCamera(enabled: boolean): Observable<void>;
    abstract setAudio(volume: number): Observable<void>;

    abstract startCall(data: CallData): Observable<CallStatusType>;
    abstract endCall(): Observable<void>;

    abstract setMicDevice(device: Partial<DeviceInfo>): Observable<void>;
    abstract setCameraDevice(device: Partial<DeviceInfo>): Observable<void>;
    abstract setAudioDevice(device: Partial<DeviceInfo>): Observable<void>;
}
